export function LandingCapabilities() {
  return (
    <section className="wf-section" id="capabilities">
      <div className="wf-extraction-banner">
        <h2>Every step of the statement — measured, traceable, and yours.</h2>
        <div>
          <h3>Extract terms without the squint test</h3>
          <p>
            AI pulls commission, expenses, waterfall shares, and residual obligations straight from
            the long-form contract — with extracted terms ready for your review.
          </p>
        </div>
      </div>
      <div className="wf-two-columns wf-catalog-copy">
        <div>
          <h2>One platform for screen and sound catalogs.</h2>
          <p>
            Bring contract terms, party shares, and sales into one reporting workflow. Review every
            allocation before approving a statement.
          </p>
        </div>
        <ul>
          <li>Track licensing tied to each contract</li>
          <li>Party terms route each sale to its recipients</li>
          <li>Import sales and costs from CSV files</li>
          <li>Review waterfall calculations and download party statements</li>
        </ul>
      </div>
    </section>
  );
}
